import React from 'react';
import { Box, Typography } from '@drone-js/core';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { useSelector } from 'react-redux';
import { selectScreenSize } from 'store/slice/screen';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { StringFormatter } from '@agoda/react-handyman';
import { ActivitiesGlobalKeywordSearchNothingFoundSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesGlobalKeywordSearchNothingFoundSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';

const TextSearchGlobalKeywordNoResults: React.FC<{ searchText: string; cms: CmsValue }> = (props) => {
    const { searchText, cms } = props;
    const screenSize = useSelector(selectScreenSize);
    const padding = screenSize.tabletOrDesktop ? '8' : '16';
    const paddingBottom = screenSize.tabletOrDesktop ? '8' : undefined;
    const paddingTop = screenSize.tabletOrDesktop ? '8' : '4';

    React.useEffect(() => {
        trackElementEvent<ActivitiesGlobalKeywordSearchNothingFoundSeenEventActivitiesFieldsV1>(ActivitiesGlobalKeywordSearchNothingFoundSeenEventActivitiesManifestV1.ids, {
            search_phrase: searchText,
        });
    }, [searchText]);

    return (
        <Box
            px={padding}
            pt={paddingTop}
            pb={paddingBottom}
            borderRadius="8"
            display="flex"
            data-testid="activities-nothing-found"
            data-element-name="activities-nothing-found"
            textAlign="start"
            width="100%"
        >
            <div>
                <Typography variant="body-s-strong">{StringFormatter.format(cms['366444'], searchText)}</Typography>
                <Typography variant="body-s" textColor="base.subtle">
                    {cms[366445]}
                </Typography>
            </div>
        </Box>
    );
};
TextSearchGlobalKeywordNoResults.displayName = 'TextSearchGlobalKeywordNoResults';

export default TextSearchGlobalKeywordNoResults;
